import React from 'react';
import LegalPage from '../../components/LegalPage';

export default function Cookies() {
  return (
    <LegalPage eyebrow="Legal" title="Cookie Policy" updated="July 2025">
      <p>This Cookie Policy explains how www.cheapora.com (operated by Waan Travel Pte. Ltd.) uses cookies and similar technologies.</p>
      <h2>1. What are cookies</h2>
      <p>Cookies are small text files stored on your device by your browser. They allow websites to remember information about your visit, such as preferences and settings.</p>
      <h2>2. Categories we may use</h2>
      <ul>
        <li><strong>Strictly necessary</strong> — required for the Website to function (for example, remembering your search inputs across pages).</li>
        <li><strong>Analytics</strong> — used to understand how visitors interact with the Website so we can improve it.</li>
        <li><strong>Marketing / affiliate</strong> — once live, may be used by our travel partners to attribute referrals or bookings originating from Cheapora.</li>
      </ul>
      <h2>3. Managing cookies</h2>
      <p>You can control or delete cookies via your browser settings. Blocking some cookies may affect the functionality of the Website.</p>
      <h2>4. Third-party providers</h2>
      <p>Once travel-partner integrations are activated, third-party providers you are redirected to may set their own cookies subject to their own policies.</p>
      <h2>5. Contact</h2>
      <p><a href="mailto:admin@waantravel.com">admin@waantravel.com</a></p>
    </LegalPage>
  );
}
